type NativeAction = "downloadImage" | "downloadVideo";

interface MessageHandler {
  isApp: boolean;
  postMessage: (message: object, action: NativeAction) => void;
  formatMessage: (action: string, data: any) => string;
}

export const messageHandler = (): MessageHandler => {
  const isApp = window.isMobileSplash;
  const formatMessage = (messageAction: string, messageBody: Object) => {
    return JSON.stringify({ action: messageAction, body: messageBody });
  };

  const post = (message: object, action: NativeAction) => {
    window.ReactNativeWebView.postMessage(
      formatMessage(action as string, message)
    );
  };

  return {
    isApp,
    postMessage: post,
    formatMessage: formatMessage,
  };
};

const ReactNativeMessageHandler = messageHandler();

export default ReactNativeMessageHandler;
